module.exports = { id: "hills", url: "/build/app/img/symbols.svg#hills", viewBox: "", toString: function() { return this.url; } };